import type { NextPage, GetStaticPropsContext } from 'next'
import { Box } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { MarkdownLoader } from '@/components/MarkdownLoader'
import SeoHead from '@/components/seo-head'

const PaymentPlanAgreementPage: NextPage = () => {
  const t = useTranslations()
  return (
    <>
      <SeoHead
        title={t('agreements.seo.title', {
          agreementName: t('agreements.payment-plan'),
        })}
        breadcrumbTitle={t('agreements.seo.breadcrumb', {
          agreementName: t('agreements.payment-plan'),
        })}
        description={t('agreements.seo.description', {
          agreementName: t('agreements.payment-plan'),
        })}
      />
      <Box py={12}>
        <MarkdownLoader mdFile={`payment-plan-agreement.md`} />
      </Box>
    </>
  )
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`../../locales/${locale}.json`)).default,
    },
  }
}

export default PaymentPlanAgreementPage
